import { FormSelect } from "components/Forms/FormSelect";
import {
  getAmountCode,
  getAmountCodes,
  stateUsesRangeCodes,
} from "encamp-shared/src/constants/storageAmounts";
import { isNil } from "lodash-es";
import React, { useEffect, useMemo } from "react";
import { useFormContext } from "react-hook-form";

interface AmountCodeSelectProps {
  name: string;
  label: string;
  state?: string | null;
  amount?: number | null;
  disabled?: boolean;
}

export function AmountCodeSelect({
  name,
  label,
  state,
  amount,
  disabled = false,
}: AmountCodeSelectProps) {
  const { setValue } = useFormContext();
  const usesRangeCodes = stateUsesRangeCodes(state);

  // If max or average amount is set, then use the calculated value
  useEffect(() => {
    if (usesRangeCodes && amount) {
      const calculatedCode = Number(getAmountCode(amount, state ?? ""));
      setValue(name, calculatedCode);
    }
  }, [amount, name, setValue, state, usesRangeCodes]);

  const selectItems = useMemo(
    () =>
      Object.entries(getAmountCodes(state ?? "")).map(([value, display]) => ({
        value: Number(value),
        display,
      })),
    [state]
  );

  // No point offering a code CERS will never read; CA amounts are exact.
  if (!usesRangeCodes) {
    return null;
  }

  return (
    <FormSelect
      label={label}
      selectItems={selectItems}
      name={name}
      disabled={!isNil(amount) || disabled}
    />
  );
}
